import {
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  GET_MASTERDATABYNAME,
  jsonApiHeader,
  SERVICE_CODE,
  SAVE_SERVICE_CODE,
  GET_MASTERSERVICECODE_BYID,
  DELETE_SERVICE_CODE,
  ServiceCodeActionTypes,
  showSuccessMessage,
  showWarningMessage,
  showErrorMessage,
} from '../constants/ApiConstants';
import GlobalVariables, { checkHttpStatusAuthCheck,createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';


export const getMasterData = () => {

  return (dispatch, getState) => {

    dispatch(actionCreator(ServiceCodeActionTypes.get_master_data.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'masterunittype,masterroundingrules' }),
      // body: JSON.stringify({ 'masterdata': 'masterservicecode,masterunittype,masterroundingrules' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function (response) {
        dispatch(actionCreator(ServiceCodeActionTypes.get_master_data.SUCCESS, response));
      })
      .catch(function (error) {

      });
  };
};

export const getServiceCodeBySearchText = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ServiceCodeActionTypes.get_ServiceCode_BySeachText.REQUEST));
    let query_params = createSearchUrl(searchObj);
    // console.log('searchObj.............',searchObj);
    // fetch(`${SERVICE_CODE}?filter[serviceCode]=like:${searchText}&filter[description]=like:${searchText}`, {
    fetch(`${SERVICE_CODE}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(ServiceCodeActionTypes.get_ServiceCode_BySeachText.SUCCESS, response));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const getServiceCodeList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ServiceCodeActionTypes.get_service_codes.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    // console.log('`${SERVICE_CODE}${query_params}`.....................',`${SERVICE_CODE}${query_params}`)
    fetch(`${SERVICE_CODE}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log(response)
        dispatch(actionCreator(ServiceCodeActionTypes.get_service_codes.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};


// save SERVICE Codes ...
export const saveServiceCodes = (formData) => {
  // console.log('JSON.stringify(formData).............',JSON.stringify(formData))
  return (dispatch, getState) => {
    dispatch(actionCreator(ServiceCodeActionTypes.post_service_code.REQUEST));
    fetch(`${SAVE_SERVICE_CODE}`, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          dispatch(actionCreator(ServiceCodeActionTypes.post_service_code.SUCCESS, response));
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
          } else {
            showErrorMessage(response.message);
          }
          let searchObj = {
            pageNumber: 1,
            pageSize: GlobalVariables.PageSize,
          };

          dispatch(getServiceCodeList(searchObj));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};


// delete ServiceCode Codes ...
export const deleteServiceCode = (servicecodeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ServiceCodeActionTypes.delete_service_code.REQUEST));    
    fetch(`${DELETE_SERVICE_CODE}?servicecodeId=${servicecodeId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(ServiceCodeActionTypes.delete_service_code.SUCCESS, response));
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
        } else if (response.statusCode === 204) {
          showSuccessMessage(response.message);
        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
        }
        else if (response.statusCode === 422) {
          showWarningMessage(response.message);
        }
        else {
          showErrorMessage(response.message);
        }

        let searchObj = {
          pageNumber: 1,
          pageSize: GlobalVariables.PageSize,
        };
        dispatch(getServiceCodeList(searchObj));

      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

// get service code details using api call ...
export const getServiceCodeDetails = (serviceCodeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ServiceCodeActionTypes.get_masterservicecode_by_Id.REQUEST));
    // let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_MASTERSERVICECODE_BYID}?serviceCodeId=${serviceCodeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(ServiceCodeActionTypes.get_masterservicecode_by_Id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error master service code get details ...', error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/serviceCode/actions/ServiceCodeActions.js